// AdminLogin.jsx
import React, { useState } from "react";
import "./AdminLogin.css"; // Custom CSS
import { useDispatch } from "react-redux";
import { onAdminLogin } from "../../redux/homeAction";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

const AdminLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    if (token) {
      // agar already logged in hai to login page na dikhe
      navigate("/", { replace: true });
    }
  }, [navigate]);

  const handleLogin = (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError("Please enter email and password");
      return;
    }
    const data = {
      email: email,
      password: password,
    };
    dispatch(onAdminLogin(setLoader, setError, data, navigate));
  };

  return (
    <div className="login-container d-flex align-items-center justify-content-center">
      <div className="login-card p-4 shadow rounded">
        <h2 className="text-center mb-4">Admin Login</h2>
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              placeholder="admin@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" className="btn btn-primary w-100">
            Login
          </button>
        </form>
        <p className="text-center text-muted mt-3">
          &copy; {new Date().getFullYear()} Admin Panel
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
